import styled, { css } from 'styled-components';
import { desktop_medium, mobile_xl } from '../../../../global/mediaQueryMixin';

const OuterDiv = styled.div`
  position: relative;
  width: 100%;
  height: 100dvh;
  background-color: var(--background-secondary);
  overflow: hidden;
`;

const MainDiv = styled.div`
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  ${mobile_xl(css`
    align-items: flex-start;
  `)}
`;
const Icon = styled.div`
  position: absolute;
  top: 20px;
  padding: 9px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 8px;
  :hover {
    background-color: var(--neutral-secondary);
    svg path {
      fill: var(--text-primary);
    }
  }
  &.closeIcon {
    right: 20px;
  }
  &.backIcon {
    left: 20px;
  }
  ${mobile_xl(css`
    position: unset;
    padding: 6px;
    svg {
      width: 20px;
      height: 20px;
    }
  `)}
`;

const MainSection = styled.div`
  max-width: 1280px;
  width: 100%;
  display: flex;
  align-items: flex-start;
  justify-content: center;
  gap: 40px;
  overflow: visible;
  padding-inline: 40px;
  ${desktop_medium(css`
    padding-inline: 0;
    position: absolute;
    left: 80px;
  `)};
  @media (max-width: 767px) {
    position: relative;
    left: unset;
  }
  ${mobile_xl(css`
    flex-direction: column;
    align-items: flex-start;
    justify-content: flex-start;
    gap: 24px;
  `)}
`;

export { OuterDiv, MainDiv, Icon, MainSection };
